type DayRowActionsInput = {
  canEdit: boolean;
  canEditExpenses: boolean;
};

type DayRowActions = {
  withActionBar: boolean;
  canEditRows: boolean;
  canDeleteRows: boolean;
};

/**
 * Which actions a day of the week offers.
 *
 * The row icons follow the Save button: a week that takes no writes — one the
 * consultant withdrew, one already submitted — used to show an edit pencil and a
 * delete bin that changed the form and had nothing to persist it with.
 */
export function dayRowActions({
  canEdit,
  canEditExpenses
}: DayRowActionsInput): DayRowActions {
  const withActionBar = canEditExpenses || canEdit;

  return {
    withActionBar,
    canEditRows: withActionBar,
    canDeleteRows: withActionBar
  };
}
